import styled from 'styled-components';
import { COLORS, MQS } from '../../../app/common/constants/styles';

export const ServiceInfo = styled.div`
    width: 100%;
`;

export const CheckAgreement = styled.div`
    text-align: left;
    font-size: 0.875rem;
    width: 100%;
`;

export const CheckAgreementText = styled.p`
    display: inline;
    line-height: 1.5;
`;
export const CheckAgreementLink = styled.a`
    color: ${COLORS.rakutenRed};
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: none;
    &:hover {
        font-weight: bold;
    }
`;

export const SwitchToggleButtonContainer = styled.div`
    margin-left: 1em;
`;

export const OptionalConsentContent = styled.p`
    text-align: justify;
    font-size: 0.8125rem;
    width: 100%;
`;

export const OptionalConsent = styled.div`
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 20px;
    position: relative;
    min-height: 35px;

    & p {
        font-size: 0.875rem;
        color: ${COLORS.grey7};
        width: 100%;
        @media (min-width: ${MQS.mq3Min}) {
            padding-right: 50px;
        }
    }
`;
